/**
* @Description 文件功能说明：应用明细
* @Author
* @Time 2022/1/20
**/

/* HTML */
<template>
    <div class="form-model-view">
    	<div class="title-item-box">
            <span>定位地图信息</span>
            <el-button class="title-item-btn" icon="el-icon-delete" style="float: right;" v-show="!editFlag" @click="del">删除</el-button>
    		<el-button class="title-item-btn" icon="el-icon-save" style="float: right;" v-show="editFlag" @click="cancel">取消</el-button>
    		<el-button class="title-item-btn" icon="el-icon-save" style="float: right;" v-show="editFlag" @click="save">保存编辑</el-button>
    		<el-button class="title-item-btn" icon="el-icon-edit" style="float: right;" v-show="!editFlag" @click="edit">编辑</el-button>
    	</div>
    	<div class="form-unit-box">
    		<el-form :model="rowForm" ref="rowForm" :rules="rules" label-width="140px" style="min-width: 450px;">
                <el-form-item label="地图id：" >
                    {{nodeData.id}}
                </el-form-item>
                <el-form-item label="地图名称：" prop="mapName">
                    <div v-if="editFlag">
                        <el-input v-model="rowForm.mapName"/>
                    </div>
                    <div v-else>
                        {{nodeData.name}}
                    </div>
                </el-form-item>
                <div v-if="nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'">
                    <el-form-item label="起始里程：" prop="start">
                        <div v-if="editFlag">
                            <el-input v-model="rowForm.start">
                                <template slot="append">米</template>
                            </el-input>
                        </div>
                        <div v-else>
                            {{nodeData.node.startPointX + ' 米'}}
                        </div>
                    </el-form-item>
                    <el-form-item label="隧道宽度：" prop="width">
                        <div v-if="editFlag">
                            <el-input v-model="rowForm.width">
                                <template slot="append">米</template>
                            </el-input>
                        </div>
                        <div v-else>
                            {{nodeData.node.scaleY.split('/')[1] + ' 米'}}
                        </div>
                    </el-form-item>
                    <el-form-item label="定位方向：" prop="direction">
                        {{nodeData.node.direction?'往大里程定位':'往小里程定位'}}
                    </el-form-item>
                    <el-form-item label="是否有掌子面：" prop="face" style="display: none;">
                        <div v-if="editFlag">
                            <el-radio-group v-model="rowForm.face">
                                <el-radio class="radio" :label="0" >否</el-radio>
                                <el-radio class="radio" :label="1" >是</el-radio>
                            </el-radio-group>
                        </div>
                        <div v-else>
                            {{nodeData.node.face==0?'否':'是'}}
                        </div>
                    </el-form-item>
                </div>
                
                <!-- 定制隧道 start -->
                <div v-else-if="nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e11'">
                    <el-form-item v-if="editFlag" label="选择地图：" prop="mapType">
                        <el-select v-model="rowForm.mapType" placeholder="请选择地图" @change="changeMapType" style="width: 100%;">
                            <el-option v-for="(item, key) in customTunnels" :key="key" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="row-items-1" label-width="0px" v-show="!emptyMapUrl">
                        <div style="width: 100%;overflow: hidden;">
                            <div class="raphae-map-box h-m-400">
                                <SubRaphaelMap ref="svgMap" :mapEleId="'addMapId'"/>
                            </div>
                        </div>
                    </el-form-item>
                    <template >
                    	<el-form-item label-width="100px" label="定位组 ①"></el-form-item>
                    	<el-form-item label-width="205px" label="实际坐标点集合（米）:" prop="">
                            <el-input v-if="editFlag" v-model="rowForm.groupPoints[0].realPoints" type="textarea" class="inp-pd-5 mini-textarea" />
                            <div v-else>
	                        	{{rowForm.groupPoints[0].realPoints}}
	                        </div>
                        </el-form-item>
                        <el-form-item label-width="205px" label="地图坐标点集合1（px）:" prop="">
                            <el-input v-if="editFlag" v-model="rowForm.groupPoints[0].mapPoints1" type="textarea" class="inp-pd-5 mini-textarea" />
                            <div v-else>
	                        	{{rowForm.groupPoints[0].mapPoints1}}
	                        </div>
                        </el-form-item>
                        <el-form-item label-width="205px" label="地图坐标点集合2（px）:" prop="">
                            <el-input v-if="editFlag" v-model="rowForm.groupPoints[0].mapPoints2" type="textarea" class="inp-pd-5 mini-textarea" />
                            <div v-else>
	                        	{{rowForm.groupPoints[0].mapPoints2}}
	                        </div>
                        </el-form-item>
                        <el-form-item label-width="205px" label="宽度 :" prop="">
                            <el-input v-if="editFlag" v-model="rowForm.groupPoints[0].width">
                                <template slot="append">米</template>
                            </el-input>
                            <div v-else>
	                        	{{rowForm.groupPoints[0].width + ' 米'}}
	                        </div>
                        </el-form-item>
                        <el-form-item label-width="205px" label="基站位置 :" prop="">
	                        <el-select v-model="rowForm.groupPoints[0].pointLocation" placeholder="请选择基站位置" :disabled="!editFlag" style="width: 100%;">
	                            <el-option v-for="(item, index) in pointLocations" :key="index" :label="item.label" :value="item.val"></el-option>
	                        </el-select>
                        </el-form-item>
                    </template>
                    <template v-if="rowForm.mapType == 3 && rowForm.groupPoints[1]">
                    	<el-form-item label-width="100px" label="定位组 ②"></el-form-item>
                    	<el-form-item label-width="205px" label="实际坐标点集合（米）:" prop="">
                            <el-input v-if="editFlag" v-model="rowForm.groupPoints[1].realPoints" type="textarea" class="inp-pd-5 mini-textarea" />
                            <div v-else>
	                        	{{rowForm.groupPoints[1].realPoints}}
	                        </div>
                        </el-form-item>
                        <el-form-item label-width="205px" label="地图坐标点集合1（px）:" prop="">
                            <el-input v-if="editFlag" v-model="rowForm.groupPoints[1].mapPoints1" type="textarea" class="inp-pd-5 mini-textarea" />
                            <div v-else>
	                        	{{rowForm.groupPoints[1].mapPoints1}}
	                        </div>
                        </el-form-item>
                        <el-form-item label-width="205px" label="地图坐标点集合2（px）:" prop="">
                            <el-input v-if="editFlag" v-model="rowForm.groupPoints[1].mapPoints2" type="textarea" class="inp-pd-5 mini-textarea" />
                            <div v-else>
	                        	{{rowForm.groupPoints[1].mapPoints2}}
	                        </div>
                        </el-form-item>
                        <el-form-item label-width="205px" label="宽度 :" prop="">
                            <el-input v-if="editFlag" v-model="rowForm.groupPoints[1].width">
                                <template slot="append">米</template>
                            </el-input>
                            <div v-else>
	                        	{{rowForm.groupPoints[1].width + ' 米'}}
	                        </div>
                        </el-form-item>
                        <el-form-item label-width="205px" label="基站位置 :" prop="">
	                        <el-select v-model="rowForm.groupPoints[1].pointLocation" placeholder="请选择基站位置" :disabled="!editFlag" style="width: 100%;">
	                            <el-option v-for="(item, index) in pointLocations" :key="index" :label="item.label" :value="item.val"></el-option>
	                        </el-select>
                        </el-form-item>
                    </template>
                    <!--
                    <template v-if="rowForm.mapType == 3 && rowForm.groupPoints[2]">
                    	<el-form-item label-width="100px" label="定位组 ③"></el-form-item>
                    	<el-form-item label-width="205px" label="实际坐标点集合（米）:" prop="">
                            <el-input v-if="editFlag" v-model="rowForm.groupPoints[2].realPoints" type="textarea" class="inp-pd-5 mini-textarea" />
                            <div v-else>
	                        	{{rowForm.groupPoints[2].realPoints}}
	                        </div>
                        </el-form-item>
                        <el-form-item label-width="205px" label="地图坐标点集合1（px）:" prop="">
                            <el-input v-if="editFlag" v-model="rowForm.groupPoints[2].mapPoints1" type="textarea" class="inp-pd-5 mini-textarea" />
                            <div v-else>
	                        	{{rowForm.groupPoints[2].mapPoints1}}
	                        </div>
                        </el-form-item>
                        <el-form-item label-width="205px" label="地图坐标点集合2（px）:" prop="">
                            <el-input v-if="editFlag" v-model="rowForm.groupPoints[2].mapPoints2" type="textarea" class="inp-pd-5 mini-textarea" />
                            <div v-else>
	                        	{{rowForm.groupPoints[2].mapPoints2}}
	                        </div>
                        </el-form-item>
                        <el-form-item label-width="205px" label="宽度 :" prop="">
                            <el-input v-if="editFlag" v-model="rowForm.groupPoints[2].width">
                                <template slot="append">米</template>
                            </el-input>
                            <div v-else>
	                        	{{rowForm.groupPoints[2].width + ' 米'}}
	                        </div>
                        </el-form-item>
                    </template>
                    -->
                </div>
                <!-- 定制隧道 end -->
                
                <div v-else>
                    <template>
                    	<!-- 自动生成地图 start -->
	                    <el-form-item class="vertical-form-item p-t-5 p-l-20 content-pt-35" prop="mapFile" v-if="autoMapFlag" v-show="editFlag" style="margin-bottom: 20px;">
							<span slot="label">
								<span style="padding-right: 0px;"><font color="#F56C6C">*</font>生成地图<i style="padding-left: 0px;">：填写实际测量数据之后点击 生成地图 按钮，自动生成地图 </i></span>
							</span>
							
							<el-form-item class="vertical-form-item m-b-0 float-left p-r-10" label="测量距离横向, 纵向：" prop="realWidth" style="width: calc((100% - 90px) / 2)">
	                            <el-input v-model="rowForm.realWidth">
	                                <template slot="append">米</template>
	                            </el-input>
	                        </el-form-item>
	                        <el-form-item class="vertical-form-item m-b-0 float-left p-r-10" prop="realHeight" style="width: calc((100% - 90px) / 2)">
	                            <el-input v-model="rowForm.realHeight">
	                                <template slot="append">米</template>
	                            </el-input>
	                        </el-form-item>
							<el-form-item class="vertical-form-item m-b-0 float-left p-r-10" style="width: 90px;">
	                            <el-button type="primary" @click.native="creatFile" size="small" style="height: 46px;">生成地图</el-button>
	                        </el-form-item>
	                    </el-form-item>
	                    <!-- 自动生成地图 end -->
                    	
                    	<el-form-item v-else label="上传地图：" prop="mapFile" v-show="editFlag">
	                        <el-upload
	                            style="display: inline-block;"
	                            ref="uploadImg"
	                            accept="image/jpeg,image/jpg,image/png"
	                            :auto-upload="false"
	                            :show-file-list="false"
	                            :before-upload="beforeUpload"
	                            :on-success="uploadSuccess"
	                            :on-error="uploadError"
	                            :action="upload.uploadUrl"
	                            :headers="upload.myHeaders"
	                            :on-change="(file,fileList)=>{return changeFile(file,fileList)}"
	                        ><el-button type="primary" size="mini">上传地图</el-button></el-upload>
	                    </el-form-item>
                    </template>
                    
                    <el-form-item class="row-items-1" label-width="0px" v-show="!emptyMapUrl">
                        <div style="width: 100%;overflow: hidden;">
                            <div class="raphae-map-box h-m-400">
                                <SubRaphaelMap ref="svgMap" :mapEleId="'addMapId'"/>
                            </div>
                        </div>
                    </el-form-item>

                    <!-- 起始点 start -->
                    <el-form-item class="vertical-form-item m-b-10 p-t-5 p-l-20 content-pt-35" v-if="nodeData.parentNode.hasMap || !autoMapFlag || !editFlag">
		            	<span slot="label">
							<span>① 起点坐标<i v-if="editFlag">{{!autoMapFlag ? '：双击地图获取地图起点坐标X/Y' : ''}}</i></span>
						</span>

                        <div v-if="editFlag">
                            <el-form-item v-if="!autoMapFlag" :class="{'vertical-form-item': editFlag,'float-left row-items-2 p-l-10 label-pr-0': true}" label="地图坐标X, Y：" prop="startPointXPx">
                                <el-input v-model="rowForm.startPointXPx" :disabled="true">
                                    <template slot="append">px</template>
                                </el-input>
                            </el-form-item>
                            <el-form-item v-if="!autoMapFlag" :class="{'vertical-form-item': editFlag,'float-left row-items-2 p-l-10 label-pr-0': true}" prop="startPointYPx">
                                <el-input v-model="rowForm.startPointYPx" :disabled="true">
                                    <template slot="append">px</template>
                                </el-input>
                            </el-form-item>
                            <el-form-item :class="{'vertical-form-item': editFlag,'float-left row-items-2 p-l-10 label-pr-0': true}" v-if="nodeData.parentNode.hasMap != 1" label="测量坐标X, Y：" prop="startPointX">
                                <el-input v-model="rowForm.startPointX">
                                    <template slot="append">米</template>
                                </el-input>
                            </el-form-item>
                            <el-form-item :class="{'vertical-form-item': editFlag,'float-left row-items-2 p-l-10 label-pr-0': true}" v-if="nodeData.parentNode.hasMap == 1" label="测量坐标偏移X, Y：" prop="offsetX">
                                <el-input v-model="rowForm.offsetX">
                                    <template slot="append">米</template>
                                </el-input>
                            </el-form-item>
                            <el-form-item :class="{'vertical-form-item': editFlag,'float-left row-items-2 p-l-10 label-pr-0': true}" v-if="nodeData.parentNode.hasMap != 1" prop="startPointY">
                                <el-input v-model="rowForm.startPointY">
                                    <template slot="append">米</template>
                                </el-input>
                            </el-form-item>
                            <el-form-item :class="{'vertical-form-item': editFlag,'float-left row-items-2 p-l-10 label-pr-0': true}" v-if="nodeData.parentNode.hasMap == 1" prop="offsetY">
                                <el-input v-model="rowForm.offsetY">
                                    <template slot="append">米</template>
                                </el-input>
                            </el-form-item>

                        </div>
                        <div v-else>
                            <el-form-item label="地图坐标X, Y">
                                {{"（单位：Px）：" + rowForm.startPointXPx + ", " +rowForm.startPointYPx}}
                            </el-form-item>

                            <el-form-item label="测量坐标X, Y" v-if="nodeData.parentNode.hasMap != 1">
                                {{"（单位：米）：" + rowForm.startPointX + ", " + rowForm.startPointY}}
                            </el-form-item>
                            <el-form-item label="测量坐标偏移X, Y" label-width="140px" v-if="nodeData.parentNode.hasMap == 1">
                                {{"（单位：米）：" + rowForm.offsetX + ", " + rowForm.offsetY}}
                            </el-form-item>

                        </div>
                    </el-form-item>
                    <!-- 起始点 end -->

                    <!-- 比例 start -->
                    <el-form-item class="vertical-form-item m-b-10 p-l-20 content-pt-40" label="比例" v-if="!autoMapFlag || !editFlag">
						<span slot="label">
							<span style="padding-right: 10px;">② 地图比例</span>
							<template v-if="editFlag && !emptyMapUrl">
								<el-button v-if="!fingerDrawFlag" @click="toggleFingerDraw(true)" type="primary" size="mini">绘制基准矩形</el-button>
								<el-button v-else @click="toggleFingerDraw(false)" type="primary" size="mini">结束绘制</el-button>
							</template>
						</span>

                        <div v-if="editFlag">
                            <span style="position: absolute;left: 50%; top: 60px;">/</span>
                            <el-form-item :class="{'vertical-form-item': editFlag,'float-left row-items-2 p-l-10 label-pr-0': true}" label-width="125px" label="地图距离/测量距离（X）：" prop="scaleX_map">
                                <el-input v-model="rowForm.scaleX_map" class="inp-pd-5" @blur="changeScale" :disabled="false">
                                    <template slot="append">px</template>
                                </el-input>
                            </el-form-item>
                            <el-form-item :class="{'vertical-form-item': editFlag,'float-left row-items-2 p-l-10 label-pr-0': true}" prop="scaleX_real">
                                <el-input v-model="rowForm.scaleX_real" class="inp-pd-5" @blur="changeScale">
                                    <template slot="append">米</template>
                                </el-input>
                            </el-form-item>

                            <span style="position: absolute;left: 50%; top: 140px;">/</span>
                            <el-form-item :class="{'vertical-form-item': editFlag,'float-left row-items-2 p-l-10 label-pr-0': true}" label="地图距离/测量距离（Y）：" prop="scaleY_map">
                                <el-input v-model="rowForm.scaleY_map" class="inp-pd-5" @blur="changeScale" :disabled="false">
                                    <template slot="append">px</template>
                                </el-input>
                            </el-form-item>
                            <el-form-item :class="{'vertical-form-item': editFlag,'float-left row-items-2 p-l-10 label-pr-0': true}" prop="scaleY_real">
                                <el-input v-model="rowForm.scaleY_real" class="inp-pd-5" @blur="changeScale" >
                                    <template slot="append">米</template>
                                </el-input>
                            </el-form-item>
                            
                            <el-form-item class="vertical-form-item float-left row-items-1 p-r-10" label="地图顶点坐标（Px）格式（x0,y0;x1,y1）:" prop="tunnelPoints">
                                <el-input v-model="rowForm.tunnelPoints" type="textarea" class="inp-pd-5" @blur="changeScale">
                                    <template slot="append">px</template>
                                </el-input>
                            </el-form-item>
                        </div>
                        <div v-else>
                            <el-form-item label="地图与测量比例X">
                                {{"（Px/米）：" + rowForm.scaleX_map + "/" + rowForm.scaleX_real}}
                            </el-form-item>
                            <el-form-item label="地图与测量比例Y">
                                {{"（Px/米）：" + rowForm.scaleY_map + "/" + rowForm.scaleY_real}}
                            </el-form-item>
                            <el-form-item label="地图顶点坐标" v-show="rowForm.tunnelPoints">
                                {{"(Px)：" + rowForm.tunnelPoints}}
                            </el-form-item>
                        </div>

                    </el-form-item>
                    <!-- 比例 end -->

                    <el-form-item class="vertical-form-item m-b-10 p-t-5 p-l-20 content-pt-35" v-if="nodeData.parentNode.hasMap == 1">
	            	<span slot="label">
						<span>{{!autoMapFlag || !editFlag ? '③ ' : '② '}}地图相对高度</span>
					</span>
                        <div v-if="editFlag">
                            <el-form-item label-width="140px" label="地图相对高度：" prop="offsetZ">
                                <el-input v-model="rowForm.offsetZ">
                                    <template slot="append">米</template>
                                </el-input>
                            </el-form-item>
                        </div>
                        <div v-else>
                            <el-form-item label="地图相对高度">
                                {{"（单位：米）：" + rowForm.offsetZ}}
                            </el-form-item>
                        </div>
                    </el-form-item>

                </div>

	        </el-form>
    	</div>
    </div>
</template>

/* JS */
<script>
    // 公共变量
	import GlobalFun from '@/global/global-function';
	// 公共变量
	import GlobalVariable from '@/global/global-variable';
    import ApiOam from '@/request/api-oam';
    import SubRaphaelMap from '@/components/SubRaphaelMap';
    // 地图 img
	import defaultImg from '@/static_dazzle/images/template/grid-20px-500x500.png';
    export default {
        /**
         * @Des 组件名
         * @Auth
         * @Date 2022/1/20
         */
        name: 'MapDetail',
        /**
         * @Des 数据接收类型
         * @Auth
         * @Date 2022/1/20
         */
        props: {
            // 节点信息
            nodeData: Object,
        },
        /**
         * @Des 组件引用
         * @Auth
         * @Date
         */
        components: {
            // svg地图
            SubRaphaelMap,
        },
        /**
         * @Des 数据定义
         * @Auth
         * @Date 2022/1/20
         */
        data() {
            return{
                editFlag: false,
                operationLock: false,
                // 地图为空
                emptyMapUrl: true,
                rowForm: {
                    mapName: '',
                    // 地图 img addr
                    mapAddr: '',
                    // 选取 地图
                    mapFile: '',
                    mapUrl: '',
                    mapType: '', // 1,2,3 定制隧道
                    groupPoints: [
                    	{number: 1, width: 20, realPoints: '', mapPoints1: '', mapPoints2: '', pointLocation: 1},
                    	{number: 2, width: 20, realPoints: '', mapPoints1: '', mapPoints2: '', pointLocation: 1},
                    	{number: 3, width: 20, realPoints: '', mapPoints1: '', mapPoints2: '', pointLocation: 1},
                    ],
                    realWidth: '',
                    realHeight: '',
                    offsetX: 0,
                    offsetY: 0,
                    offsetZ: 0,
                    startPointX: 0,
                    startPointY: 0,
                    startPointZ: 0,
                    startPointXPx: '',
                    startPointYPx: '',
                    scaleX: '',
                    scaleY: '',
                    scaleX_map: '',
                    scaleY_map: '',
                    scaleX_real: '',
                    scaleY_real: '',
                    start: 0,
                    direction: true,
                    width: 0,
                    height: 0,
                    face: 0,
                    tunnelPoints: '',
                },
                row:{},
                /**
                 * @Des 地图信息
                 * @Auth
                 * @Date
                 */
                mapOption: {},
                // 地图模块
                mapSub: null,
                // 绘制自定义矩形 flag
                fingerDrawFlag: false,
				
				// flag 自动生成地图
				autoMapFlag: false,
				// flag 点击按钮
				handleAutoFlag: false,
				
                upload:{
                    myHeaders: {
                        token: this.$store.state.token,
                        lang: this.$store.state.lang,
                        loginDevice: this.$store.state.loginDevice
                    },
                    uploadUrl: ApiOam.Upload_Map_Uri,
                },
                
                // falg 定制隧道
                customTunnelFlag: false,
                // 定制隧道
                customTunnels: {
                	1: {id: 1, name: '4号隧道', src: '/static/tunnel_store/cz_4.png', width: 3001, height: 2000},
                	2: {id: 2, name: '5号隧道', src: '/static/tunnel_store/cz_5.png', width: 3000, height: 2000},
                	3: {id: 3, name: '6号隧道', src: '/static/tunnel_store/cz_6.png', width: 3001, height: 2000},
                },
                // 基站位置
                pointLocations: [{val: 1, label: '第一条线'}, {val: 2, label: '第二条线'}],
                
                rules:{
                    name: [
                        { required: true, message: '地图名称不能为空', trigger: 'blur' }
                    ],
                    mapUrl: [
                        { required: false, message: '地图地址不能为空', trigger: 'blur' },
                        {
                            validator: (rule, value, callback) => {
                                if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('地图地址不能为空'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    mapFile: [
                        {
                            validator: (rule, value, callback) => {
                                if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                                    callback()
                                }else {
                                    if (this.$checkEmpty(value) && this.$checkEmpty(this.rowForm.mapUrl)) {
                                        if (this.autoMapFlag) {
                                    		new callback(new Error('请生成地图'))
                                    	} else {
                                    		new callback(new Error('请选择地图'))
                                    	}
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],// mapFile
                    realWidth: [
                        {
                            validator: (rule, value, callback) => {
                                if(!this.handleAutoFlag){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('横向测量距离不能为空'))
                                    } else if (!(parseFloat(value) > 0)) {
                                    	new callback(new Error('横向测量距离应为大于0的数字'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],// realWidth
                    realHeight: [
                        {
                            validator: (rule, value, callback) => {
                                if(!this.handleAutoFlag){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('纵向测量距离不能为空'))
                                    } else if (!(parseFloat(value) > 0)) {
                                    	new callback(new Error('纵向测量距离应为大于0的数字'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],// realHeight
                    startPointX: [
                        { required: false, message: '起始点实际坐标X不能为空', trigger: 'blur' },
                        {
                            validator: (rule, value, callback) => {
                                if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('起始点实际坐标X不能为空'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    startPointY: [
                        { required: true, message: '起始点实际坐标Y不能为空', trigger: 'blur' },
                        {
                            validator: (rule, value, callback) => {
                                if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('起始点实际坐标Y不能为空'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    startPointZ: [
                        { required: true, message: '地图高度不能为空', trigger: 'blur' },
                        {
                            validator: (rule, value, callback) => {
                                if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('地图高度不能为空'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    offsetX: [
                        { required: true, message: '起始点实际X偏移量不能为空', trigger: 'blur' },
                        {
                            validator: (rule, value, callback) => {
                                if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('起始点实际X偏移量不能为空'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    offsetY: [
                        { required: true, message: '起始点实际Y偏移量不能为空', trigger: 'blur' },
                        {
                            validator: (rule, value, callback) => {
                                if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('起始点实际Y偏移量不能为空'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    offsetZ: [
                        { required: true, message: '相对高度不能为空', trigger: 'blur' },
                        {
                            validator: (rule, value, callback) => {
                                if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('相对高度不能为空'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    startPointXPx: [
                        { required: true, message: '起始点地图坐标X不能为空', trigger: 'blur' },
                        {
                            validator: (rule, value, callback) => {
                                if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('起始点地图坐标X不能为空'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    startPointYPx: [
                        { required: true, message: '起始点地图坐标Y不能为空', trigger: 'blur' },
                        {
                            validator: (rule, value, callback) => {
                                if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('起始点地图坐标Y不能为空'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    scaleX: [
                        { required: true, message: 'X比例不能为空', trigger: 'blur' },
                        {
                            validator: (rule, value, callback) => {
                                if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('X比例不能为空'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    scaleY: [
                        { required: true, message: 'Y比例不能为空', trigger: 'blur' },
                        {
                            validator: (rule, value, callback) => {
                                if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('Y比例不能为空'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    scaleX_map: [
                        { required: true, message: 'X方向地图距离不能为空', trigger: 'blur' },
                        {
                            validator: (rule, value, callback) => {
                                if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('X方向地图距离不能为空'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    scaleX_real: [
                        { required: true, message: 'X方向测量距离不能为空', trigger: 'blur' },
                        {
                            validator: (rule, value, callback) => {
                                if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('X方向测量距离不能为空'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    scaleY_map: [
                        { required: true, message: 'Y方向地图距离不能为空', trigger: 'blur' },
                        {
                            validator: (rule, value, callback) => {
                                if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('Y方向地图距离不能为空'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    scaleY_real: [
                        { required: true, message: 'Y方向测量距离不能为空', trigger: 'blur' },
                        {
                            validator: (rule, value, callback) => {
                                if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('Y方向测量距离不能为空'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        },
                    ],
                    start: [
                        { required: true, message: '起始里程不能为空', trigger: 'blur' },
                        {
                            validator: (rule, value, callback) => {
                                if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('起始里程不能为空'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        },
                    ],
                    width: [
                        { required: true, message: '隧道宽度不能为空', trigger: 'blur' },
                        {
                            validator: (rule, value, callback) => {
                                if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('隧道宽度不能为空'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        },
                    ],
                },// rules
            }
        },
        /**
         * @Des 加载完成
         * @Auth
         * @Date
         */
        mounted(){
            // flag 自动生成地图
            this.autoMapFlag = this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e8';
            // 重新加载数据
            this.$nextTick(() => {
                this.searchRow();
            });
        },
        /**
         * @Des 销毁
         * @Auth
         * @Date
         */
        destroyed() {
            // 销毁 svg地图
            this.$refs.svgMap && this.$refs.svgMap.destroySvg();
        },
		/**
		 * @Des 监听
		 * @Auth
		 * @Date
		 */
		watch: {
			/**
			 * @Des 地图数据
			 * @Auth
			 * @Date
			 */
			nodeData: {
				handler(newVal, oldVal){
					this.$nextTick(() => {
						// 查询地图
						this.searchRow();
		            });
				},
				immediate: true,
				deep:true,
			}
		},
        /**
         * @Des 方法定义
         * @Auth
         * @Date
         */
        methods:{
            /**
	         * @Des 检索是否有地图
	         * @Auth
	         * @Date
	         */
            checkMapUrl() {
                this.emptyMapUrl = this.$checkEmpty(this.rowForm.mapFile) && this.$checkEmpty(this.rowForm.mapUrl) && this.$checkEmpty(this.rowForm.mapType);
            },

            /**
             * 查询地图
             */
            searchRow() {
                this.rowForm = Object.assign({}, this.rowForm, this.nodeData.node);
                
                this.rowForm.start =  this.nodeData.node.startPointX;
                this.rowForm.direction =  this.nodeData.node.direction;
                this.rowForm.width =  this.nodeData.node.scaleY ? this.nodeData.node.scaleY.split("/")[1] : '';
                this.rowForm.face =  this.nodeData.node.face;
                
				// 定制隧道
				this.rowForm.mapType =  this.nodeData.node.mapType;
				this.rowForm.groupPoints =  this.nodeData.node.groupPoints ? JSON.parse(this.nodeData.node.groupPoints) : null;
				
				
                // 检索是否有地图
                this.checkMapUrl();

                // 比例 X
                if (!this.$checkEmpty(this.rowForm.scaleX)) {
                    let scaleXs = this.rowForm.scaleX.split('/');
                    if (scaleXs.length == 2) {
                        this.rowForm.scaleX_map = scaleXs[0];
                        this.rowForm.scaleX_real = scaleXs[1];
                    } else {
                        this.rowForm.scaleX_map = '';
                        this.rowForm.scaleX_real = '';
                    }
                }
                // 比例 Y
                if (!this.$checkEmpty(this.rowForm.scaleY)) {
                    let scaleYs = this.rowForm.scaleY.split('/');
                    if (scaleYs.length == 2) {
                        this.rowForm.scaleY_map = scaleYs[0];
                        this.rowForm.scaleY_real = scaleYs[1];
                    } else {
                        this.rowForm.scaleY_map = '';
                        this.rowForm.scaleY_real = '';
                    }
                }
				
				// 定制隧道
				if (this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e11') {
					// 地图数据 初始化
					this.initMapData();
				} else if (!(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6')) {
                    // 地图信息
                    this.mapOption = Object.assign({}, this.rowForm);
                    //this.mapOption.mapUrl = GlobalVariable.BASE_PATH + this.mapOption.mapUrl;
                    this.mapOption.mapUrl = 'data:image/png;base64,' + this.mapOption.mapUrl;
					
                    this.$nextTick(() => {
                    	// 初始化 svg地图
	                    if(!this.mapSub){
	                        this.mapSub = this.$refs.svgMap;
	                    }
                    	// 初始化地图
	                    this.mapSub.initMap(this.mapOption);
	                    // 绘制圆点
	                    this.mapSub.initDrawDisc([this.mapOption.startPointXPx, this.mapOption.startPointYPx].join(','), 5);
	                    // 允许 比例图元
	                    this.mapSub.allowShowScaleLine(!this.autoMapFlag);
	                    // 更改地图比例
	                    this.changeScale();
                    });
				}
				
            },

            /**
             * 编辑
             */
            edit(){
                this.rowForm.id = this.nodeData.id;
                //this.rowForm.name = this.nodeData.name;
                this.editFlag = true;
				
				// 地图数据 初始化
                this.initMapData();
				
                // 双击取点
                this.mapSub && this.mapSub.allowDrawDisc(!this.autoMapFlag && !this.customTunnelFlag, (startX, startY) => {
                    // 起始点X
                    this.rowForm.startPointXPx = startX;
                    // 起始点X
                    this.rowForm.startPointYPx = startY;

                    // 表单校验
					this.$refs.rowForm.validateField('startPointXPx', error => {});
					this.$refs.rowForm.validateField('startPointYPx', error => {});
                });
            },
            /**
             * 取消
             */
            cancel(){
                // 清空验证
                this.$refs.rowForm.clearValidate();
                
                this.editFlag = false;
                // 交互锁
                this.operationLock = false;

                if(true || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                    if (this.mapSub) {
                        // 双击取点
                        this.mapSub.allowDrawDisc(false, (startX, startY) => {
                            // 起始点X
                            this.rowForm.startPointXPx = startX;
                            // 起始点X
                            this.rowForm.startPointYPx = startY;
                        });
                        // 开始/结束 获取基准矩形
                        this.toggleFingerDraw(false);
                        // 更改地图比例
                        this.changeScale();
                        // 结束绘制
                        this.mapSub.stopFingerArea();
                    }
                }

                // 查询数据
                this.searchRow();
            },
            /**
             * 保存
             */
            save(){
                // 交互锁
                if(this.operationLock) return false;
                this.$refs.rowForm.validate(valid => {
                    if (!valid) return false;
                    // 交互锁
                    this.operationLock = true;
					
					// 提交数据 交互
					this.requestSubmit();
					
                    return false;
                  if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6') {
                    if (!this.$checkEmpty(this.rowForm.mapFile)) {
                      // 编辑 && 更改地图

                      // 上传图片
                      this.$refs['uploadImg'].submit();

                    } else {
                      // addr
                      this.rowForm.mapAddr = this.rowForm.mapUrl;

                      // 提交数据 交互
                      this.requestSubmit();
                    }
                  }else{
                    this.requestSubmit();
                  }

                });
            },
            /**
             * @Des 提交交互
             * @Auth
             * @Date
             */
            requestSubmit() {
            	// 父级node有地图 => 重置起点和偏移量
            	if (this.nodeData.parentNode.hasMap == 1) {
            		// 父级node有地图

            		this.rowForm.startPointX = 0;
                    this.rowForm.startPointY = 0;
                    this.rowForm.startPointZ = 0;
            	} else {
            		// 没有区域 || 没有区域地图

            		this.rowForm.offsetX = 0;
                    this.rowForm.offsetY = 0;
                    this.rowForm.offsetZ = 0;
            	}
            	
            	if(!this.rowForm.mapType && !this.$checkEmpty(this.mapOption.mapUrl) && (this.mapOption.mapUrl.indexOf(",") == -1 || this.mapOption.mapUrl.split(",").length < 2)){
                    this.$message({
                        message: '地图信息不能为空',
                        type: 'error',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                }
            	
				// 定制隧道
				let groupPoints = Object.assign([], this.rowForm.groupPoints);
				if (!this.rowForm.mapType) {
					groupPoints = null;
				} else if (this.rowForm.mapType != 3) {
					this.$checkEmpty(groupPoints[0]) && groupPoints.splice(0, 1, {number: 1, width: 20, realPoints: '', mapPoints1: '', mapPoints2: '', pointLocation: 1});
					groupPoints.splice(1, 2);
				} else {
					this.$checkEmpty(groupPoints[0]) && groupPoints.splice(0, 1, {number: 1, width: 20, realPoints: '', mapPoints1: '', mapPoints2: '', pointLocation: 1});
					this.$checkEmpty(groupPoints[1]) && groupPoints.splice(1, 1, {number: 2, width: 20, realPoints: '', mapPoints1: '', mapPoints2: '', pointLocation: 1});
					// this.$checkEmpty(groupPoints[2]) && groupPoints.splice(2, 1, {number: 3, width: 20, realPoints: '', mapPoints1: '', mapPoints2: '', pointLocation: 1});
					groupPoints.splice(2, 1);
					/*
					if (!this.$checkEmpty(groupPoints[2]) && this.$checkEmpty(groupPoints[2].width)) {
					}
					*/
				}
				
				
            	let formData = Object.assign({}, {
                    projectId: this.nodeData.project.projectId,
                    areaId: this.nodeData.parentId,
                    mapId: this.nodeData.id,
                    mapName: this.rowForm.mapName,
                    mapAddr: !this.$checkEmpty(this.mapOption.mapUrl)?this.mapOption.mapUrl.split("base64,")[1]:"",//this.rowForm.mapAddr,
                    startPointX: this.rowForm.startPointX,
                    startPointY: this.rowForm.startPointY,
                    startPointZ: this.rowForm.startPointZ,
                    offsetX: this.rowForm.offsetX,
                    offsetY: this.rowForm.offsetY,
                    offsetZ: this.rowForm.offsetZ,
                    startPointXPx: this.rowForm.startPointXPx,
                    startPointYPx: this.rowForm.startPointYPx,
                    scaleX: [this.rowForm.scaleX_map, this.rowForm.scaleX_real].join('/'),//this.rowForm.scaleX,
                    scaleY: [this.rowForm.scaleY_map, this.rowForm.scaleY_real].join('/'),//this.rowForm.scaleY,
                    start: this.rowForm.start,
                    mapHeight: this.mapOption.mapUrl ? this.mapOption.mapHeight : this.rowForm.mapHeight,
                    mapWidth: this.mapOption.mapUrl ? this.mapOption.mapWidth : this.rowForm.mapWidth,
                    width: this.rowForm.width,
                    face: this.rowForm.face,
                    direction: this.rowForm.direction,
                    tunnelPoints: this.rowForm.tunnelPoints,
                    mapType: this.rowForm.mapType, // 1,2,3 定制隧道
                    groupPoints: groupPoints ? JSON.stringify(groupPoints) : null,
                });
            	
            	this.$request.postJsonRequest(ApiOam.Update_Map_Uri, formData).then(result => {
                    if (result.code == 0) {
                        this.$message({
                            message: '保存成功！',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        
                        let nodeData = Object.assign({}, this.nodeData);
						nodeData.name = formData.mapName;
						nodeData.node = Object.assign({}, nodeData.node, formData);
						if (!this.$checkEmpty(formData.mapAddr)) {
							nodeData.node.mapUrl = formData.mapAddr;
						}
                        if(this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e4' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e5' || this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e6'){
                        	this.rowForm.width =  parseFloat(this.rowForm.width) == parseInt(this.rowForm.width) ? parseFloat(this.rowForm.width).toFixed(1) : this.rowForm.width;
                            nodeData.name = this.rowForm.mapName;
                            nodeData.node.startPointX = this.rowForm.start;
                            nodeData.node.direction =  this.rowForm.direction;
                            nodeData.node.scaleY = this.nodeData.node.scaleY.split("/")[0] + "/"  + this.rowForm.width;
                            nodeData.node.face =  this.rowForm.face;

                        }else{
                            //this.findMapDetail(nodeData.id);
                        }
                        this.$emit('setSelectVal', nodeData, true);

                        this.$nextTick(() => {
                        	this.cancel();
                        });
                    } else {
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }

                    // 交互锁
                    this.operationLock = false;
                }).catch(error => {
                	// 交互锁
                	this.operationLock = false;
                	console.error('地图编辑异常', ApiOam.Update_Map_Uri, error);
                })
            },

            /**
             * 删除
             */
            del(){
                // 交互锁
                if (this.operationLock) return false;
                this.$confirm('确认要删除【' + this.nodeData.name + '】吗？','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$request.postJsonRequest(ApiOam.Delete_Map_Uri, {
                        mapId: this.nodeData.id
                    }).then(result => {
                        if(result.code == 0){
                            this.$message({
                                message: '【' + this.nodeData.name + '】删除成功！',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            this.$emit('setSelectVal', false, true);
                        }else{
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                        // 交互锁
                    	this.operationLock = false;
                    }).catch(error => {
                        // 交互锁
                    	this.operationLock = false;
                    	console.error('删除地图异常', ApiOam.Delete_Map_Uri, error);
                    })
                }).catch(() => {
                    // 交互锁
                    this.operationLock = false;
                })
            },

            /**
             * @Des 文件上传 change
             * @Auth
             * @Date
             */
            beforeUpload(file){
                // 上传之前
                //console.log(file)
                let extension = file.name.substring(file.name.lastIndexOf('.')+1);
                let size = file.size/1024/1024;
                // console.log(extension, size)
                if(['png', 'jpg', 'jpeg'].indexOf(extension) === -1) {
                    this.$message.warning('只能上传后缀是 .png/.jpg/.jpeg 的文件');
                } else if(size > 100) {
                    // this.$message.warning('文件大小不得超过100M');
                }
            },
            /**
             * @Des 文件上传 change
             * @Auth
             * @Date
             */
            uploadSuccess(res, file, fileList) {
                // 上传成功
                //console.log(res, file, fileList);
                if(res.code == 0){
                    // 返回数据
                    // console.log(res.data)

                    let mapAddr = '';
                    if (!this.$checkEmpty(res.data) && !this.$checkEmpty(res.data.path)) {
                        mapAddr = res.data.path;
                    }

                    this.rowForm.mapFile = '';
                    this.rowForm.mapAddr = mapAddr;

                    // 提交数据 交互
                    this.requestSubmit();

                }else{
                    this.$message({
                        type: 'error',
                        message: res.msg ,
                        dangerouslyUseHTMLString: true
                    });
                    // 交互锁
                    this.operationLock = false;
                }
            },
            /**
             * @Des 文件上传 change
             * @Auth
             * @Date
             */
            uploadError(err, file, fileList) {
                // 上传失败
                this.$message({
                    type: 'error',
                    message: err.msg ,
                    dangerouslyUseHTMLString: true
                });
                // 交互锁
                this.operationLock = false;
            },
            /**
             * @Des 文件上传 change
             * @Auth
             * @Date
             */
            changeFile(file,fileList) {
                // console.log(file)

                // 交互锁
                this.operationLock = false;

                let _this = this;
                // file 转换成 base64
                GlobalFun.readFileImg(file.raw, data => {
                    this.mapOption.mapUrl = data.src;
                    this.mapOption.mapHeight = data.height;
                    this.mapOption.mapWidth = data.width;
                    this.rowForm.mapFile = data.src;

					// 检索是否有地图
					this.checkMapUrl();
                    // console.log(this.rowForm)

                    // 初始化 svg地图
                    if(!this.mapSub){
                        this.mapSub = this.$refs.svgMap;
                    }
                    this.mapSub.initMap(this.mapOption);
                    // 双击取点
                    this.mapSub.allowDrawDisc(true, (startX, startY) => {
                        // 起始点X
                        this.rowForm.startPointXPx = startX;
                        // 起始点X
                        this.rowForm.startPointYPx = startY;

                        // 表单校验
						this.$refs.rowForm.validateField('startPointXPx', error => {});
						this.$refs.rowForm.validateField('startPointYPx', error => {});
                    });// allowDrawDisc
                    // 允许 比例图元
                    this.mapSub.allowShowScaleLine(true);

                    // 更改地图比例
                    this.changeScale();
                });
            },// changeFile
			
			/**
			 * @Des 地图数据 初始化
			 * @Auth
			 * @Date
			 */
            initMapData() {
            	// flag 自动生成地图
				this.autoMapFlag = this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e8';
            	// 自动生成地图
            	if (this.autoMapFlag) {
            		// 地图数据
            		this.rowForm['startPointXPx'] = 0;
            		this.rowForm['startPointYPx'] = 0;
            		this.rowForm['scaleX_map'] = 20;
            		this.rowForm['scaleY_map'] = 20;
            		this.rowForm['scaleX_real'] = 2;
            		this.rowForm['scaleY_real'] = 2;
            		this.rowForm['scaleX'] = [this.rowForm.scaleX_map, this.rowForm.scaleX_real].join('/');
            		this.rowForm['scaleY'] = [this.rowForm.scaleY_map, this.rowForm.scaleY_real].join('/');
            	}
            	
            	// falg 定制隧道
                this.customTunnelFlag = this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e11';
                // 定制隧道
                if (this.customTunnelFlag) {
                	// 定制隧道
                	this.rowForm['mapType'] = this.rowForm['mapType'] || 1;
                	
	            	// 切换地图 （定制隧道）
            		this.changeMapType();
                }
            },// initMapData
			/**
			 * @Des 生成地图
			 * @Auth
			 * @Date
			 */
            creatFile() {
            	// flag 点击按钮
				this.handleAutoFlag = true;
				this.$refs.rowForm.clearValidate(['mapFile']);
            	
            	let validFlag = true;
            	this.$refs.rowForm.validateField('realWidth', (err) => {
            		if (err) validFlag = false;
            	});
            	this.$refs.rowForm.validateField('realHeight', (err) => {
            		if (err) validFlag = false;
            	});
            	// flag 点击按钮
				this.handleAutoFlag = false;
            	
            	// 验证未通过 中止
            	if (!validFlag) return false;
            	
            	let scaleXs = [this.rowForm.scaleX_map, this.rowForm.scaleX_real];
            	let scaleYs = [this.rowForm.scaleY_map, this.rowForm.scaleY_real];
            	// 参数 地图
				this.mapOption.mapWidth = Math.ceil((this.rowForm.realWidth * scaleXs[0] / scaleXs[1]) / 20) * 20;
				this.mapOption.mapHeight = Math.ceil((this.rowForm.realHeight * scaleYs[0] / scaleYs[1]) / 20) * 20;
				
				// 比例 地图
				this.mapOption.scaleX = [this.rowForm.scaleX_map, this.rowForm.scaleX_real].join('/');
				this.mapOption.scaleY = [this.rowForm.scaleY_map, this.rowForm.scaleY_real].join('/')
				
				// 裁剪的地图
				this.$SubFn.sliceImg({
					src: defaultImg,
					rect: {
						x: 0, // 截取方格左上角横坐标
						y: 0, // 截取方格左上角纵坐标
						width: this.mapOption.mapWidth, // 截取方格宽度
						height: this.mapOption.mapHeight // 截取方格高度
					}
				}).then(result => {
					
					this.mapOption.mapUrl = result;
                    this.rowForm.mapFile = result;
					
					// 检索是否有地图
					this.checkMapUrl();
                    // console.log(this.rowForm)

                    // 初始化 svg地图
                    if(!this.mapSub){
                        this.mapSub = this.$refs.svgMap;
                    }
                    this.mapSub.initMap(this.mapOption);
                    // 绘制圆点
                    this.mapSub.initDrawDisc([this.rowForm.startPointXPx, this.rowForm.startPointYPx].join(','), 5);
                    // 双击取点
                    /*this.mapSub.allowDrawDisc(true, (startX, startY) => {
                        // 起始点X
                        this.rowForm.startPointXPx = startX;
                        // 起始点X
                        this.rowForm.startPointYPx = startY;

                        // 表单校验
						this.$refs.rowForm.validateField('startPointXPx', error => {});
						this.$refs.rowForm.validateField('startPointYPx', error => {});
                    });*/
                    // 允许 比例图元
                    this.mapSub.allowShowScaleLine(false);

                    // 更改地图比例
                    this.changeScale();
					
				}).catch(error => {
					this.mapOption.mapUrl = '';
                    this.rowForm.mapFile = '';
                    // 检索是否有地图
					this.checkMapUrl();
				});// this.$SubFn.sliceImg
            },// creatFile
			
            /**
			 * @Des 切换地图 （定制隧道）
			 * @Auth
			 * @Date
			 */
			changeMapType() {
				if (this.$checkEmpty(this.rowForm.groupPoints)) {
					this.rowForm.groupPoints = [];
				}
				this.$checkEmpty(this.rowForm.groupPoints[0]) && this.rowForm.groupPoints.splice(0, 1, {number: 1, width: 20, realPoints: '', mapPoints1: '', mapPoints2: '', pointLocation: 1});
				if (!this.rowForm.groupPoints[0].pointLocation) {
					this.rowForm.groupPoints[0].pointLocation = 1;
				}
				if (this.rowForm.mapType == 3) {
					this.$checkEmpty(this.rowForm.groupPoints[1]) && this.rowForm.groupPoints.splice(1, 1, {number: 2, width: 20, realPoints: '', mapPoints1: '', mapPoints2: '', pointLocation: 1});
					if (!this.rowForm.groupPoints[1].pointLocation) {
						this.rowForm.groupPoints[1].pointLocation = 1;
					}
					/*
					this.$checkEmpty(this.rowForm.groupPoints[2]) && this.rowForm.groupPoints.splice(2, 1, {number: 3, width: 20, realPoints: '', mapPoints1: '', mapPoints2: '', pointLocation: 1});
					if (!this.rowForm.groupPoints[2].pointLocation) {
						this.rowForm.groupPoints[2].pointLocation = 1;
					}
					*/
				}
				
				const data = this.customTunnels[this.rowForm.mapType];
				
				this.mapOption.mapUrl = GlobalVariable.PAGE_PATH + data.src;
                this.mapOption.mapHeight = data.height;
                this.mapOption.mapWidth = data.width;

				// 检索是否有地图
				this.checkMapUrl();
				
				// 延迟加载
				this.$nextTick(() => {
					// 初始化 svg地图
	                if(!this.mapSub){
	                    this.mapSub = this.$refs.svgMap;
	                }
	                this.mapSub.initMap(this.mapOption);
	                // 双击取点
	                this.mapSub.allowDrawDisc(false, (startX, startY) => {
	                    // 起始点X
	                    this.rowForm.startPointXPx = startX;
	                    // 起始点X
	                    this.rowForm.startPointYPx = startY;
	
	                    // 表单校验
						this.$refs.rowForm.validateField('startPointXPx', error => {});
						this.$refs.rowForm.validateField('startPointYPx', error => {});
	                });
	                // 允许 比例图元
	                this.mapSub.allowShowScaleLine(true);
	
	                // 更改地图比例
	                this.changeScale();
				});
			},// 切换地图 （定制隧道）
            
            /**
			 * @Des 开始/结束 获取基准矩形
			 * @Auth
			 * @Date
			 */
			toggleFingerDraw(flag) {
				// 空值 中止
				if (this.$checkEmpty(this.mapSub)) return false;

				// 绘制自定义矩形 flag
				this.fingerDrawFlag = flag;

				if (this.fingerDrawFlag) {
					// 开始绘制
					this.mapSub.setFingerArea((poinsStr, ptOpt) => {
						let scaleX_map = Math.abs(ptOpt.endPointX - ptOpt.startPointX);
						let scaleY_map = Math.abs(ptOpt.endPointY - ptOpt.startPointY);

						// 地图信息
						this.rowForm.scaleX_map = Math.round(scaleX_map);
						this.rowForm.scaleY_map = Math.round(scaleY_map);

						// 表单校验
						this.$refs.rowForm.validateField('scaleX_map', error => {});
						this.$refs.rowForm.validateField('scaleY_map', error => {});
					});
				} else {
					// 结束绘制
					this.mapSub.stopFingerArea(null, true);
				}

			},// toggleFingerDraw

			/**
			 * @Des 更改地图比例
			 * @Auth
			 * @Date
			 */
			changeScale () {
				// 自动生成地图 中止
				if (this.autoMapFlag) return false;
				// 定制隧道 中止
				if (this.customTunnelFlag) return false;
				
				let mOption = {mkey: 'scale'};
				// scaleX
				if (!this.$checkEmpty(this.rowForm.scaleX_map) && !this.$checkEmpty(this.rowForm.scaleX_real)) {
					mOption.scaleX = [this.rowForm.scaleX_map, this.rowForm.scaleX_real].join('/');
				}
				// scaleY
				if (!this.$checkEmpty(this.rowForm.scaleY_map) && !this.$checkEmpty(this.rowForm.scaleY_real)) {
					mOption.scaleY = [this.rowForm.scaleY_map, this.rowForm.scaleY_real].join('/');
				}
				// 设置地图参数 mkey
				this.mapSub && this.mapSub.setMapParam(Object.assign({}, mOption));
			},// changeScale

        },// methods

    }
</script>

/* CSS */
<style lang="scss" scoped >
	/deep/ .mini-textarea .el-textarea__inner {
		height: 42px;
		min-height: 42px!important;
		line-height: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/components_pages/Organization/MapDetail.vue